import React, { useState, useEffect } from 'react';
import Banner from './banner/Banner';
import AgentMarketPlace, { AgentMarketPlaceItemWithFilter } from './agentMarketPlace/AgentMarketPlace';
import Faq, { userAgentFaqs } from '../../shared/faq/Faq';
import Footer from '../../shared/footer/Footer';
import Header from '../../shared/header/Header';
import PromtChat from './promtChat/PromtChat';
import CommingSoonChat from './commingSoon/CommingSoonChat';

const UserAgent = () => {
  const [showChat, setShowChat] = useState<boolean>(false);
  const [showCommingSoonChat, setShowCommingSoonChat] = useState<boolean>(false);
  const [isUploadRequired, setIsUploadRequired] = useState<boolean>(false);
  const [file_format_supported, setfile_format_supported] = useState<string[]>([]);
  const [agentDetails, setAgentDetails] = useState<AgentMarketPlaceItemWithFilter | null>(null);

  // const whyAgentSectionRef = useRef<HTMLDivElement>(null);
  const handleExploreAgentsClick = () => {
    const section = document.getElementById('why-agent-section');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.error("Section with ID 'why-agent-section' not found");
    }
  };

  useEffect(() => {
    const shouldScroll = localStorage.getItem('scrollToWhySection') === 'true';
    if (!showChat && shouldScroll) {
      const timeout = setTimeout(() => {
        const section = document.getElementById('why-agent-section');
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        } else {
          console.error('not found');
        }
        localStorage.removeItem('scrollToWhySection');
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [showChat]);

  return (
    <div>
      {showChat && agentDetails ? (
        <>
          <Header />
          {showCommingSoonChat ? (
            <CommingSoonChat
              setShowCommingSoonChat={setShowCommingSoonChat}
              setShowChat={setShowChat}
              agentDetails={agentDetails}
            />
          ) : (
            <PromtChat
              setShowChat={setShowChat}
              agentDetails={agentDetails}
              isUploadRequired={isUploadRequired}
              file_format_supported={file_format_supported}
            />
          )}
        </>
      ) : (
        <div>
          <Header />
          <Banner onExploreAgentsClick={handleExploreAgentsClick} />
          <AgentMarketPlace
            setShowChat={setShowChat}
            setAgentDetails={setAgentDetails}
            setIsUploadRequired={setIsUploadRequired}
            setfile_format_supported={setfile_format_supported}
            setShowCommingSoonChat={setShowCommingSoonChat}
          />
          <Faq faqs={userAgentFaqs} />
          <Footer />
        </div>
      )}
    </div>
  );
};

export default UserAgent;
